<template>
  <v-card class="v-card--material pa-3">
    <v-card-title>Información pago</v-card-title>
    <v-row>
      <v-col cols="12" md="6">
        <v-menu ref="fechaPago" v-model="fechaPago" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
          <template v-slot:activator="{ on }">
            <v-text-field v-model="dataForm.fecha" prepend-inner-icon="mdi-calendar-outline" color="gold" label="Fecha" readonly v-on="on" />
          </template>
          <v-date-picker v-model="dataForm.fecha" color="gold" landscape scrollable locale="es-419" no-title @input="enviarAPadre" />
        </v-menu>
      </v-col>
      <v-col cols="12" md="6">
        <base-upload-files folder="/documentaciones/pagos" label-text="Documento" tipo="pdf" :documento-id="dataForm.documentacion_id" @documento="agregarDocumentacion($event)" />
      </v-col>
      <v-col cols="12" md="6" class="pt-0 pb-0">
        <validation-provider v-slot="{ errors }" name="notas" rules="max:250">
          <v-textarea v-model="dataForm.notas" color="gold" counter rows="3" :error-messages="errors" name="input-6-2" label="Notas" @blur="enviarAPadre" />
        </validation-provider>
      </v-col>
      <v-col cols="12" md="6" class="pt-0 pb-0">
        <validation-provider v-slot="{ errors }" name="observaciones" rules="max:250">
          <v-textarea v-model="dataForm.obs" color="gold" counter rows="3" :error-messages="errors" name="input-6-3" label="Observaciones (no imprimible)" @blur="enviarAPadre" />
        </validation-provider>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import dayjs from 'dayjs'
  export default {
    name: 'InformacionPago',
    props: {
    },
    data () {
      return {
        fechaPago: false,
        dataForm: {
          fecha: '',
          notas: '',
          obs: '',
          documentacion_id: null,
        },
      }
    },
    computed: {},
    created () {
      this.iniciarNuevo()
    },
    methods: {
      iniciarNuevo () {
        this.dataForm.fecha = dayjs().format('YYYY-MM-DD')
        this.enviarAPadre()
      },
      enviarAPadre: function () {
        const informacionPago = {
          fecha: this.dataForm.fecha,
          documentacion_id: this.dataForm.documentacion_id,
          notas: this.dataForm.notas,
          obs: this.dataForm.obs,
        }
        this.$emit('actualizarPago', informacionPago)
      },
      agregarDocumentacion (documento) {
        this.dataForm.documentacion_id = documento
        this.enviarAPadre()
      },
    },
  }
</script>
